// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_bk-b";
export var colorBlue = "_bk-8";
export var colorDot = "_bk-0";
export var colorDotLarge = "_bk-2";
export var colorDotSmall = "_bk-1";
export var colorGreen = "_bk-7";
export var colorGrey = "_bk-3";
export var colorOrange = "_bk-5";
export var colorPink = "_bk-a";
export var colorPurple = "_bk-9";
export var colorRed = "_bk-4";
export var colorYellow = "_bk-6";